import { Skeleton } from '../ui/skeleton';

const XpTimelineChartSkeleton = () => {
    return (
        <div className="border border-neutral-300 rounded-xl p-6">
            <div className="flex justify-between items-center mb-4">
                <Skeleton className="h-6 w-1/4" />
                <Skeleton className="h-8 w-1/4" />
            </div>
            <Skeleton className="h-72 w-full" />
        </div>
    );
};

export default XpTimelineChartSkeleton;
